export default __webpack_public_path__ + "static/media/Martiyers4.b7c96276.jpg";